import { getCompany, getUserId } from '../_utils/storage_handler';
import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/product-weight';

export const findAllProductWeight = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const findProductWeightById = async (id) => {
    return await sendFetch(`${BASE_PATH}/id/${id}`, GET_OPTIONS);
}

export const createProductWeight = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editProductWeight = async (body) => {
    return await sendFetch(`${BASE_PATH}/edit`, POST_OPTIONS, body);
}